<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="工资日期">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'salaryDate', validatorRules.salaryDate]" style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="员工姓名">
          <j-dict-select-tag type="list" v-decorator="['username', validatorRules.username]" :trigger-change="true" dictCode="sys_user,realname,username" placeholder="请选择用户"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="基本工资">
          <a-input placeholder="请输入基本工资" v-decorator="['salaryBase', validatorRules.salaryBase]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="岗位工资">
          <a-input placeholder="请输入岗位工资" v-decorator="['salaryPost', validatorRules.salaryPost]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="绩效工资">
          <a-input placeholder="请输入绩效工资" v-decorator="['salaryPrp', validatorRules.salaryPrp]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="交通">
          <a-input placeholder="请输入交通补贴" v-decorator="['salaryPerkTraffic', validatorRules.salaryPerkTraffic]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="午餐">
          <a-input placeholder="请输入午餐补助" v-decorator="['salaryPerkLunch', validatorRules.salaryPerkLunch]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="通讯">
          <a-input placeholder="请输入通讯补贴" v-decorator="['salaryPerkTel', {}]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="合计">
          <a-input placeholder="请输入补贴合计" v-decorator="['salaryPerkCount', {}]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="薪酬合计">
          <a-input placeholder="请输入薪酬合计" v-decorator="['salaryCount', {}]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="考勤">
          <a-input placeholder="请输入考勤" v-decorator="['sign', validatorRules.sign]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="养老保险">
          <a-input placeholder="请输入养老保险" v-decorator="['socialEndowment', validatorRules.socialEndowment]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="失业保险">
          <a-input placeholder="请输入失业保险" v-decorator="['socialUnemployment', validatorRules.socialUnemployment]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="医疗保险">
          <a-input placeholder="医疗保险" v-decorator="['socialMedical', validatorRules.socialMedical]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="住房公积金">
          <a-input placeholder="住房公积金" v-decorator="['socialHousing', validatorRules.socialHousing]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="社保合计">
          <a-input placeholder="请输入社保合计" v-decorator="['socialCount', validatorRules.socialCount]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="个人所得税">
          <a-input placeholder="请输入个人所得税" v-decorator="['rate', validatorRules.rate]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="实发工资">
          <a-input placeholder="请输入实发工资" v-decorator="['netSalary', {}]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="实发比例">
          <a-input placeholder="实发比例" v-decorator="['netRate', validatorRules.netRate]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="发放金额">
          <a-input placeholder="发放金额" v-decorator="['netFact', validatorRules.netFact]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import moment from "moment"
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "HRSalaryModal",
    components: {
      JDictSelectTag
    },
    data () {
      return {
        title:"操作",
        visible: false,
        disabled: false, //是否新增
        addFlag: 0,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          username:{ rules: [{required: true, message: '请选择用户!'}] },
          salaryDate:{rules: [{required: true, message: '请选择薪酬日期!'}] },
          salaryBase:{rules: [{required: true, message: '请输入基本工资!'}] },
          salaryPost:{rules: [{required: true, message: '请输入岗位工资!'}] },
          salaryPrp:{rules: [{required: true, message: '请输入绩效工资!'}] },
          salaryPerkTraffic:{rules: [{required: true, message: '请输入交通补贴!'}] },
          salaryPerkLunch:{rules: [{required: true, message: '请输入午餐补贴!'}] },
          salaryPerkTel:{rules: [{required: true, message: '请输入通讯补贴!'}] },
          socialEndowment:{rules: [{required: true, message: '请输入养老保险!'}] },
          socialUnemployment:{rules: [{required: true, message: '请输入失业保险!'}] },
          socialMedical:{rules: [{required: true, message: '请输入医疗保险!'}] },
          socialHousing:{rules: [{required: true, message: '请输入住房公积金!'}] },
          socialCount:{rules: [{required: true, message: '请输入薪酬合计!'}] },
          netRate:{rules: [{required: true, message: '请输入实发比例!'}] },
          netFact:{rules: [{required: true, message: '请输入实际发放额!'}] }
        },
        url: {
          add: "/hr/hRSalary/add",
          edit: "/hr/hRSalary/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
        this.addFlag = 1;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.addFlag = 0;
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userId','name','salary_base','salary_post','salary_prp',
            'salary_perk_traffic','salary_perk_lunch','salary_perk_tel','salary_perk_count','salary_count',
            'sign','social_endowment','social_unemployment','social_medical','social_housing','social_count','rate',
            'net_salary','net_rate','net_fact'))
		  //时间格式化
          this.form.setFieldsValue({salaryDate:this.model.salaryDate?moment(this.model.salaryDate):null})
        });

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            formData.salaryDate = formData.salaryDate?formData.salaryDate.format('YYYY-MM-DD HH:mm:ss'):null;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>